<div class="confirmation-dialog">
  @if (title) {
    <div class="confirmation-dialog__title" [innerHTML]="title"></div>
  }
  <div class="confirmation-dialog__text" [innerHTML]="displayText"></div>
  @if (warningText) {
    <br>
    }
    @if (warningText) {
      <div class="confirmation-dialog__warning-text" [innerHTML]="warningText"></div>
    }
    <div mat-dialog-actions
         [ngClass]="{'confirmation-dialog__wrapper': !hideCancel,
          'confirmation-dialog__wrapper-for-one-button': hideCancel}">
      @if (!hideCancel) {
        <button mat-button (click)="closeDialog(false)"
        class="confirmation-dialog__cancel-button">{{cancelText || 'Cancel'}}</button>
      }
      <button mat-button (click)="closeDialog(true)" class="confirmation-dialog__send-button">
        {{confirmText}}
      </button>
    </div>
  </div>
